import { ModalOverlay, ModalOverlayProps, Modal as RACModal } from 'react-aria-components';
import { tv } from 'tailwind-variants';

const overlayStyles = tv({
  base: 'u-fixed u-top-0 u-left-0 u-w-full u-h-[--visual-viewport-height] u-isolate u-z-20 u-bg-black/[15%] u-flex u-items-center u-justify-center u-p-8 u-text-center u-backdrop-blur-lg',
  variants: {
    isEntering: {
      true: 'u-animate-in u-fade-in u-duration-200 u-ease-out'
    },
    isExiting: {
      true: 'u-animate-out u-fade-out u-duration-200 u-ease-in'
    }
  }
});

const modalStyles = tv({
  base: 'u-w-full u-max-w-5xl u-max-h-full u-relative u-overflow-y-scroll u-bg-white u-text-left u-align-middle u-shadow-2xl u-bg-clip-padding',
  variants: {
    isEntering: {
      true: 'u-animate-in u-zoom-in-105 u-ease-out u-duration-200'
    },
    isExiting: {
      true: 'u-animate-out u-zoom-out-95 u-ease-in u-duration-200'
    }
  }
});

export function Modal(props: ModalOverlayProps) {
  return (
    <ModalOverlay {...props} className={overlayStyles}>
      <RACModal {...props} className={modalStyles} />
    </ModalOverlay>
  );
}
